import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

import useBids from 'hooks/useBids';
import useProperties from 'hooks/useProperties';

import { hideDialog, showDialog } from 'state/dialog/dialog.reducer';

import Map from 'components/google/maps/map.component';
import Page from 'components/page/page.component';
import PropertiesMapList from 'components/properties-map-list/properties-map-list.component';
import PropertyDialog from 'components/property-dialog/property-dialog.component';

import AsyncIndicator from 'ui-kit/async-indicator/async-indicator';

import './style.css';

const Properties = ({ history }) => {
    const [focusedProperty, setFocusedProperty] = useState(undefined);
    const dispatch = useDispatch();
    const { isFetchingProperties, properties } = useProperties();
    const { bids } = useBids();

    const startingLocation = {
        address: '300 N High St, Muncie, IN 47305',
        lat: 40.19585,
        lng: -85.38694
    };

    const handleShowPropertyDialog = ({ id }) => {
        const property = properties.find((p) => p.id === id);
        if (dispatch && property) {
            dispatch(
                showDialog({
                    render: (props) => <PropertyDialog {...props} />,
                    props: {
                        bids: bids.filter((bid) => bid.parcelNumber === property.parcelNumber),
                        property,
                        onClose: () => {
                            dispatch(hideDialog());
                        },
                        onPlaceBidClick: () => {
                            history.push(
                                `/about/bidding?parcelNumber=${property.parcelNumber}&address=${property.address}`
                            );
                            dispatch(hideDialog());
                        }
                    }
                })
            );
        }
    };

    const handleMapListPropertyFocus = ({ property }) => {
        setFocusedProperty(property);
    };

    return (
        <Page noHero pageContentStyle={{ minHeight: '800px', width: '100%', padding: 0 }}>
            <Container fluid className="h-100 properties">
                {isFetchingProperties && (
                    <AsyncIndicator
                        className="d-flex d-sm-none properties-view-async-indicator"
                        message="Loading Properties..."
                    />
                )}
                <Row className="h-100 my-1" style={{ minHeight: '800px' }}>
                    <Col xs={12} sm={9} md={9} className="px-0">
                        <Map
                            zoomLevel={13}
                            startingLocation={startingLocation}
                            locations={properties}
                            onLocationClick={handleShowPropertyDialog}
                            focusedLocation={focusedProperty}
                        />
                    </Col>
                    <Col xs={12} sm={3} md={3} className="d-none d-sm-block properties-list-col px-0">
                        <PropertiesMapList
                            onPropertyClick={handleShowPropertyDialog}
                            onFocus={handleMapListPropertyFocus}
                        />
                    </Col>
                </Row>
            </Container>
        </Page>
    );
};

export default withRouter(Properties);
